import type { MouseEventHandler } from 'react';
import { CardBody, Card as ChakraCard } from '@chakra-ui/react';

export interface CardProps {
    id?: string;
    minW?: string;
    maxW?: string | { [key: string]: string };
    children: React.ReactNode;
    padding?: string;
    margin?: string;
    borderRadius?: string;
    onClick?: MouseEventHandler<HTMLDivElement> | undefined;
    h?: string;
    display?: string;
}
export const Card = ({
    id,
    children,
    maxW,
    minW,
    padding,
    margin,
    borderRadius,
    onClick,
    h,
    display,
}: CardProps) => {
    const defaultPadding = { base: '1rem', sm: '2rem', md: '1rem' };

    return (
        <ChakraCard
            maxW={maxW}
            minW={minW}
            data-testid={id}
            padding={padding ?? defaultPadding}
            margin={margin}
            borderRadius={borderRadius ?? { base: '0px', md: '1rem' }}
            onClick={onClick}
            cursor={onClick ? 'pointer' : 'default'}
            w="100%"
            h={h}
            display={display}
        >
            <CardBody>{children}</CardBody>
        </ChakraCard>
    );
};
